import {
  StateRule,
  StateTransitionOptions,
  StateResult,

  StateNavigationAction,
  Transition,
  // eslint-disable-next-line
  addNavigationElement,
  // eslint-disable-next-line
  addEmptyNavigationElement,
  addPreviousNext,
  // eslint-disable-next-line
  addPrevious,
  // eslint-disable-next-line
  addNext,  
  newTransition,
  newTransitionCondition
} from "../StateInterfaces";
import { NavigatonIcons } from "@/business/application/NavConst";
import {Commands} from "@/business/application/commands/Command";
import { BaseState } from "../StateMachine";
import { StateProduct } from "./StateProduct";
import { Resource } from "@/infrastructure/resource/resource";


export class StateWebShop extends BaseState {

  private mainState = "WebShop";
  private startState = "WebShop"
  private static transitions: Transition[] = [];  
  private static callingState : StateResult = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''}
  private isDirectionNext = false

  // Diesen Status setzen wenn es auf den Main-Status zurück geht. 
  private isDirectionPreviousParent = true

  public constructor() {
    super()    
  }


  
  public next(rule: StateRule, options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, false, this.mainState);
  }
  public previous(rule: StateRule,options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, true, this.mainState);
  }

  protected calculateState(rule: StateRule,options: StateTransitionOptions, isPrevious: boolean, mainState: string): StateResult {
    this.isDirectionNext = ! isPrevious
    const context = this.getContext()
    const currentResultState = context.getCurrentResultState();

    if ( isPrevious && this.isDirectionPreviousParent && currentResultState.newState === "WebShop") {
      if (StateWebShop.callingState.newMainState === "" && StateWebShop.callingState.oldMainState === "") {
        StateWebShop.callingState.newMainState = "Products"
        StateWebShop.callingState.newState = "Products"
        StateWebShop.callingState.routeName = "Products"
        StateWebShop.callingState.oldState = "WebShop"
        StateWebShop.callingState.oldMainState = "WebShop"
      }
      return this.checkResultState(StateWebShop.callingState);
    }

    let condition = this.calculateBusinessConditions(rule,this.getContext().getCurrentState());
    if ( condition === undefined || condition === null || condition.length === 0 || condition === "") {
     
      if ( currentResultState.newState === "WebShop"  && this.isDirectionNext && condition === "") {
        condition = "WebShopWarenKorb";
      }
      
      if ( currentResultState.newState === "WebShopWarenKorb"  && this.isDirectionNext && condition === "") {
        condition = "WebShopKasse";
      }

      if ( currentResultState.newState === "WebShopKasseFailed"  && this.isDirectionNext && condition === "") {
        condition = "WebShopFailed";
      }

      if ( currentResultState.newState === "WebShopKasseSuccess"  && this.isDirectionNext && condition === "") {
        condition = "WebShopSuccess";
      }


      // ---- Backward

      if ( currentResultState.newState === "WebShopKasse"  && !this.isDirectionNext && condition === "") {
        condition = "WebShopWarenKorb";
      }

      if ( currentResultState.newState === "WebShopWarenKorb"  && !this.isDirectionNext && condition === "") {
        condition = "WebShop";
      }

      if ( currentResultState.newState === "WebShop"  && !this.isDirectionNext && condition === "") {
        condition = "Product";
      }
    }

    if ( this.isDirectionNext ) {
      const nextTransition = this.getTransitions().filter(row => { 
        if ( row.nav !== StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(nextTransition[0], options);
    } else {
      const previosTransition = this.getTransitions().filter(row => { 
        if ( row.nav === StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(previosTransition[0], options);
    }
  }


  protected calculateBusinessConditions(rule: StateRule, resultState: StateResult): string {
    if ( rule.conditions === undefined || rule.conditions === null || rule.conditions.length === 0 ) {
      return "";
    }

    if (rule.conditions.length == 1) {
      return rule.conditions[0].value;
    }

    return "";
  }


  private getCallingState(condition: string) : StateResult {
    if (this.isDirectionPreviousParent) { 
      // Condition = "Login"
      StateWebShop.callingState.newMainState = condition
      StateWebShop.callingState.newState = condition
      StateWebShop.callingState.routeName = condition
      StateWebShop.callingState.oldMainState = this.mainState
      StateWebShop.callingState.oldState = this.startState

      return StateWebShop.callingState;
    }
     StateWebShop.callingState = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''};
     return StateWebShop.callingState;
  }

  public getStartTransition(condition: string) : StateResult {
    StateWebShop.transitions = []
    this.getTransitions()
    //if ( condition !== this.mainState) {
      StateWebShop.callingState = this.getCallingState(condition);
    //}
    const t = this.getTransitions()[0];
    return this.getTransition(t);
  }



  protected checkState( transition: Transition, options: StateTransitionOptions): StateResult {
    let newMainState = this.mainState    
    let skip = false
    const newResultState: StateResult = this.getTransition(transition)

    if ( this.isDirectionPreviousParent && !this.isDirectionNext) {
      newMainState = StateWebShop.callingState.oldMainState
    }
    else {      
      newMainState = transition.newMainState
      if (transition.newState == "")
        skip = true
    }

    if (!options.lookahead && transition.newState != "") {
      return this.changeResultState(transition.newMainState, newResultState);
    }
    return newResultState;
  }

  private checkResultState( stateResult: StateResult ) : StateResult {  
    const newResultState = StateWebShop.callingState;    
    return this.changeResultState(stateResult.newMainState, newResultState);      
  }

  private changeResultState(newMainStatePar: string , compResultState: StateResult) : StateResult {
    let newState: any;
    switch (newMainStatePar) {
        case "Products":
          newState = new StateProduct();
          compResultState = newState.getStartTransition("Products")
          this.getContext().transitionTo(newState,compResultState);
          break;  
        default:
          this.getContext().transitionTo(new StateWebShop(), compResultState);        
    }

    console.log("StateWebShop.changeResultState: " + JSON.stringify(compResultState))

    return compResultState;
  }




  //-- Sammlung aller Statusübergänge
  public getTransitions(): Transition[] {
    if (StateWebShop.transitions.length === 0) {

      //__ Start State egal von welcher Stufe aus
      //
      let t: Transition = { mainState: "*", newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: "*", newState: this.startState, condition: "Start"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addNavigationElement(t,2,{command: Commands.NextPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Warenkorb",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Warenkorb });
      t = addEmptyNavigationElement(t,3);
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateWebShop.transitions.push(t);

      
      

      // t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WebShop", condition: "BackToWebShop"};      
      // t = addPrevious( t, Commands.PreviousPage )
      // t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      // t = addNavigationElement(t,2,{command: Commands.NextPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Warenkorb",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Warenkorb });
      // t = addEmptyNavigationElement(t,3);
      // t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      // StateWebShop.transitions.push(t);      

      

      t = { mainState: this.mainState, newMainState: "WebShop", nav: StateNavigationAction.Next, oldState: "WebShop", newState: "WebShopWarenKorb", condition: "WebShopWarenKorb"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWebShop.transitions.push(t);

      t = { mainState: this.mainState, newMainState: "WebShop", nav: StateNavigationAction.Next, oldState: "WebShopWarenKorb", newState: "WebShopKasse", condition: "WebShopKasse"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWebShop.transitions.push(t);


      t = { mainState: this.mainState, newMainState: "WebShop", nav: StateNavigationAction.Next, oldState: "WebShopKasse", newState: "WebshopFailed", condition: "WebShopFailed"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWebShop.transitions.push(t);

      t = { mainState: this.mainState, newMainState: "WebShop", nav: StateNavigationAction.Next, oldState: "WebShopKasse", newState: "WebshopSuccess", condition: "WebShopSuccess"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWebShop.transitions.push(t);







      t = { mainState: this.mainState, newMainState: "WebShop", nav: StateNavigationAction.Previous, oldState: "WebShopKasse", newState: "WebShopWarenKorb", condition: "WebShopWarenKorb"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWebShop.transitions.push(t);

    


      //__ Backward Previous gesetzt
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WebShopWarenKorb", newState: "WebShop", condition: "WebShop"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addNavigationElement(t,2,{command: Commands.NextPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Warenkorb",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Warenkorb });
      t = addEmptyNavigationElement(t,3);
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateWebShop.transitions.push(t);
     
    }
    return StateWebShop.transitions;
  }
}
